// extracted by mini-css-extract-plugin
module.exports = {"nestedSection":"NestedSection_nestedSection__lc7a_","item":"NestedSection_item__tmCMZ","roundCorner":"NestedSection_roundCorner__avi1A"};